/**
 * Returns an iconify icon name for a given payment method string.
 */
export function getPaymentMethodIcon(method: string): string {
  const m = method.toLowerCase();
  if (m.includes('cash') || m.includes('espec') || m.includes('espèce') || m.includes('species'))
    return 'eva:bank-outline';
  if (m.includes('card') || m.includes('carte') || m.includes('cb') || m.includes('bancaire'))
    return 'eva:credit-card-outline';
  if (m.includes('check') || m.includes('chèque') || m.includes('cheque'))
    return 'eva:file-text-outline';
  if (m.includes('transfer') || m.includes('virement')) return 'eva:swap-outline';
  if (m.includes('amex')) return 'eva:credit-card-outline';
  if (m.includes('alma')) return 'eva:credit-card-outline';
  return 'eva:diagonal-arrow-right-up-outline';
}

/**
 * Returns a human-readable label for a payment method string.
 */
export function getPaymentMethodLabel(method: string, t: (k: string) => string): string {
  const m = method.toLowerCase();
  if (m.includes('cash') || m.includes('espec') || m.includes('espèce') || m.includes('species'))
    return t('cash_register.session_dialog.payment_method_cash');
  if (m.includes('card') || m.includes('carte') || m.includes('cb') || m.includes('bancaire'))
    return t('cash_register.session_dialog.payment_method_card');
  if (m.includes('check') || m.includes('chèque') || m.includes('cheque'))
    return t('cash_register.session_dialog.payment_method_check');
  if (m.includes('transfer') || m.includes('virement'))
    return t('cash_register.session_dialog.payment_method_transfer');
  return method;
}
